import React from "react";

/**
 * ACTA STANDARD PAGE
 * Design system global des pages privées.
 *
 * Objectif :
 * - uniformiser les marges
 * - uniformiser le responsive
 * - uniformiser le conteneur principal
 * - ne contient aucune logique métier
 */

export default function ActaStandardPage({
  children,
  testId,
  className = "",
}) {
  return (
    <main
      className={`
        w-full
        max-w-full
        min-w-0
        p-4
        sm:p-5
        lg:p-8
        acta-standard-page
        acta-commerce-page-standard
        ${className}
      `}
      data-testid={testId}
    >
      {children}
    </main>
  );
}
